import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  ExperimentalInputs,
  ExperimentalInputsContextProperties,
} from 'procedures/planning/ProcedurePlanTypes';
import {TimingEstimateResult} from 'studies/progress/useTimingEstimate';
import {MethodExecutionLimitState} from 'studies/typed/process-development/useMethodExecutionLimitState';
import {getStudyTypeForProcedureType} from 'studies/TypedStudyUtils';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

import {ExperimentFlowchart, ExperimentMethod} from './ExperimentalInputs';
import {ExperimentDesignEditor} from './ExperimentDesignEditor';
import ExperimentNameField from './ExperimentNameField';
import {Condition} from './useProcessDevelopmentStudyState';

export function ProcessDevelopmentStudyPlanEditor(props: {
  conditions: Array<Condition>;
  setConditions: (conditions: Array<Condition>, prevIndexes: Array<number | null>) => void;
  experimentalInputs: ExperimentalInputs | null;
  setExperimentalInputs: (experimentalInputs: ExperimentalInputs) => void;
  context: ExperimentalInputsContextProperties;
  selectedMethodId: string;
  setSelectedMethodId: (selectedMethodId: string) => void;
  procedureMethods: Array<ExperimentMethod>;
  procedureFlowchart: ExperimentFlowchart;
  methodExecutionLimitState: MethodExecutionLimitState;
  estimate: TimingEstimateResult;
  procedureType: ProcedureType;
  experimentName: string | null;
  setExperimentName: (experimentName: string | null) => void;
  hasExperimentNameTemplate: boolean;
  showExperimentName: boolean;
  dataTestAttrs?: DataTestAttrs;
}): JSX.Element {
  return (
    <div {...getTestProps(props.dataTestAttrs)}>
      {props.showExperimentName && (
        <div className={css(styles.studyPlanExperimentNameField)}>
          <ExperimentNameField
            contextLocked={props.context.locked}
            experimentName={props.experimentName}
            setExperimentName={props.setExperimentName}
            isNameAutogenerated={props.hasExperimentNameTemplate}
            studyType={getStudyTypeForProcedureType(props.procedureType)}
          />
        </div>
      )}
      <ExperimentDesignEditor
        conditions={props.conditions}
        setConditions={props.setConditions}
        experimentalInputs={props.experimentalInputs}
        setExperimentalInputs={props.setExperimentalInputs}
        context={props.context}
        selectedMethodId={props.selectedMethodId}
        setSelectedMethodId={props.setSelectedMethodId}
        procedureMethods={props.procedureMethods}
        procedureFlowchart={props.procedureFlowchart}
        methodExecutionLimitState={props.methodExecutionLimitState}
        estimate={props.estimate}
        procedureType={props.procedureType}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  studyPlanExperimentNameField: {
    paddingTop: 10,
    paddingLeft: 10,
    width: '25%',
  },
});
